import { render, staticRenderFns } from "./ResumenModelo.vue?vue&type=template&id=8764a876&scoped=true"
import script from "./ResumenModelo.vue?vue&type=script&lang=js"
export * from "./ResumenModelo.vue?vue&type=script&lang=js"
import style0 from "./ResumenModelo.vue?vue&type=style&index=0&id=8764a876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8764a876",
  null
  
)

export default component.exports